import { useEffect, useState } from "react";
import pageHeader from "../assets/banner3.png";
import { FaClock, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaGlobe, FaArrowRight } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

export default function ContactUs() {
  const [ready, setReady] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    AOS.init({ once: true, offset: 100, easing: "ease-out", duration: 600 });
    setReady(true);
  }, []);

  if (!ready) {
    return <div className="container py-5 d-flex justify-content-center">Loading...</div>;
  }

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setFormData({ name: "", email: "", subject: "", message: "" });
      alert("Thank you! Your message has been sent. We'll respond within 24 hours.");
    }, 1500);
  };

  const contactInfo = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Our Office",
      lines: ["P.O. Box 11913", "Dar es Salaam, Tanzania"],
      link: "https://maps.google.com/?q=Dar+es+Salaam+Tanzania",
      linkText: "View on Maps",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Call Us",
      lines: ["+255 782 665 569"],
      link: "tel:+255782665569",
      linkText: "Call Now",
    },
    {
      icon: <FaEnvelope />,
      title: "Email Us",
      lines: ["info@medalge.com"],
      link: "mailto:info@medalge.com",
      linkText: "Send Email",
    },
  ];

  const businessHours = [
    { days: "Monday - Friday", hours: "8:00 AM - 5:00 PM" },
    { days: "Saturday", hours: "8:00 AM - 2:00 PM" },
    { days: "Sunday", hours: "Closed" },
  ];

  return (
    <>
      {/* Minimalist Hero */}
      <section
        className="position-relative"
        style={{
          background: `linear-gradient(135deg, rgba(15,23,42,0.95), rgba(30,58,138,0.9)), url(${pageHeader})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingTop: "140px",
          paddingBottom: "100px",
        }}
      >
        <div className="container px-3">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center" data-aos="fade-up">
              
              <h1 className="display-5 font-bold text-secondary mb-4">
                Let's Build Your Next Project
              </h1>
              <p className="lead text-white-50 mb-0 font-semi-bold" style={{ maxWidth: "580px", margin: "0 auto", lineHeight: 1.7 }}>
                Reach out to Medal Global Engineering for electrical, civil, or renewable energy solutions across Tanzania.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info Cards - Minimal Grid */}
      <section className="py-5" style={{ background: "#fff" }}>
        <div className="container px-3">
          <div className="row g-4 justify-content-center">
            {contactInfo.map((item, index) => (
              <div key={item.title} className="col-md-4" data-aos="fade-up" data-aos-delay={index * 100}>
                <a
                  href={item.link}
                  target={item.link.startsWith("http") ? "_blank" : undefined}
                  rel={item.link.startsWith("http") ? "noopener noreferrer" : undefined}
                  className="d-block text-decoration-none text-inherit h-100"
                >
                  <div
                    className="p-4 h-100 border rounded-4"
                    style={{
                      borderColor: "rgba(0,0,0,0.08)",
                      transition: "all 0.2s ease",
                      background: "#fff",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "#3B82F6";
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.08)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "rgba(0,0,0,0.08)";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <div className="text-primary mb-3">{item.icon}</div>
                    <h6 className="fw-bold mb-2">{item.title}</h6>
                    {item.lines.map((line, i) => (
                      <p key={i} className="text-muted mb-1 small">{line}</p>
                    ))}
                    <span className="text-primary fw-medium small d-flex align-items-center mt-3">
                      {item.linkText} <FaArrowRight className="ms-1" size={10} />
                    </span>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

    </>
  );
}